import AppState from "../../model/app";

export function setIsLoading(setState: React.Dispatch<React.SetStateAction<AppState>>, isLoading: boolean): void {
    setState((state) => ({ ...state, isLoading: isLoading }));
}

export function setAuthenticated(
    setState: React.Dispatch<React.SetStateAction<AppState>>, authenticated: boolean,
    userId: string = "", sound: boolean, soundEffect: boolean): void {
    setState((state) => ({
        ...state, authenticated: authenticated, userId: userId,
        sound: sound === null ? state.sound : sound, soundEffect: soundEffect === null ? state.soundEffect : soundEffect }));
}

export function setStates(
    setState: React.Dispatch<React.SetStateAction<AppState>>, isLoading: boolean, authenticated: boolean,
    userId: string, sound: boolean, soundEffect: boolean): void {
    setState((state) => ({
        ...state,
        isLoading: isLoading, authenticated: authenticated, userId: userId,
        sound: sound === null ? state.sound : sound, soundEffect: soundEffect === null ? state.soundEffect : soundEffect }));
}

export function setSound(
    setState: React.Dispatch<React.SetStateAction<AppState>>, sound: boolean): void {
    setState((state) => ({ ...state, sound: sound }));
}

export function setSoundEffect(
    setState: React.Dispatch<React.SetStateAction<AppState>>, soundEffect: boolean): void {
    setState((state) => ({ ...state, soundEffect: soundEffect }));
}

export function addNotification(
    setState: React.Dispatch<React.SetStateAction<AppState>>, notification: any): void {
    notification.shown = false;
    setState((state) => ({ ...state, notifications: [notification, ...state.notifications] }));
}

export function shownNotification(
    setState: React.Dispatch<React.SetStateAction<AppState>>, notification: any): void {
    setState((state) => {
        const notifications = state.notifications;
        let index = -1;
        for (let i = 0; i < notifications.length; i++)
            if (notifications[i] === notification) {
                index = i;
                break;
            }
        if (index !== -1)
            notifications[index].shown = true;
        return {
            ...state,
            notifications: notifications,
        };
    },
    );
}
